var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#C2FAE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9171 17.0826L18.0187 13.981M21.1914 12.0882L18.5734 20.5967C18.3388 21.3593 18.2214 21.7407 18.019 21.8671C17.8435 21.9768 17.6262 21.9951 17.435 21.9158C17.2146 21.8244 17.0357 21.4672 16.6788 20.7534L15.0206 17.437C14.9639 17.3237 14.9356 17.2673 14.8977 17.2182C14.8642 17.1747 14.8254 17.1354 14.7819 17.1018C14.7339 17.0649 14.6785 17.0372 14.5702 16.983L11.2462 15.321C10.5324 14.9641 10.1755 14.7855 10.084 14.5651C10.0047 14.3739 10.0228 14.1564 10.1324 13.9809C10.2589 13.7785 10.6403 13.6609 11.4031 13.4262L19.9116 10.8082C20.5113 10.6237 20.8112 10.5315 21.0137 10.6059C21.1902 10.6706 21.3293 10.8096 21.394 10.986C21.4683 11.1885 21.3761 11.4883 21.1918 12.0873L21.1914 12.0882Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.1042a8af8245eb6d5627b219de976822.svg";
export { ForwardRef as ReactComponent };